import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {LabsState, LabsStore} from './labs.store';

@Injectable({ providedIn: 'root' })
export class LabsQuery extends QueryEntity<LabsState> {
  list$ = this.selectAll();
  filtered$ = this.selectAll({
    // filterBy: entity => entity.name
  });

  constructor(protected store: LabsStore) {
    super(store);
  }

}
